import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'observable'
})
export class ObservablePipe implements PipeTransform {
  transform(parameter: string, service: any, functionName: string, resultIsArray: boolean = true): Observable<any> {
    if (parameter && service && functionName) {
      return service[functionName](parameter);
    } else {
      return of(resultIsArray ? [] : null);
    }
  }
}
